export const formatRAMQ = (ramq: string | undefined): string | undefined => {
  const ramqWithoutSpaces = `${ramq}`.replace(/\s/g, '')
  const match = ramqWithoutSpaces.match(/^(\w{4})(\d{4})(\d{4})$/)
  if (match) {
    return `${match[1]} ${match[2]} ${match[3]}`
  }
  return undefined
}
